import { render, staticRenderFns } from "./CivilEngineering.vue?vue&type=template&id=99fce838&scoped=true"
import script from "./CivilEngineering.vue?vue&type=script&lang=js"
export * from "./CivilEngineering.vue?vue&type=script&lang=js"
import style0 from "./CivilEngineering.vue?vue&type=style&index=0&id=99fce838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fce838",
  null
  
)

export default component.exports